import { getData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";

import { PUR5010_R01Dto } from "./Dto_PUR5010_R01";
import { PUR5010_R01Filter } from "./Store_PUR5010_R01";

const baseUrl = `${config.apiUrl}/PUR5010_R01`;

// 통합 생산실적 조회 API (view 파라미터로 탭별 데이터 분기)
export const getPUR5010_R01Data = async (view: string, params: Partial<PUR5010_R01Filter>) => {
	const url = `${baseUrl}/search`;
	const requestParams = {
		logicCenter: params.logicCenter || undefined,
		warehouseCd: params.warehouseCd || undefined,
		itemCd: params.itemCd || undefined,
		brandCd: params.brandCd || undefined,
		itemStatus: params.itemStatus || undefined,
		itemAccount: params.itemAccount || undefined,
		itemGroup: params.itemGroup || undefined,
		compCd: params.compCd || undefined,

		view,
	};

    return await getData<ResponseDto<PUR5010_R01Dto[]>>(url, { params: requestParams });
};

// 통합 Excel 내보내기 API
export const exportPUR5010_R01Excel = async (view: string, params: Partial<PUR5010_R01Filter>) => {
	const url = `${baseUrl}/excel/search`;
	const requestParams = {
		logicCenter: params.logicCenter || undefined,
		warehouseCd: params.warehouseCd || undefined,
		itemCd: params.itemCd || undefined,
		brandCd: params.brandCd || undefined,
		itemStatus: params.itemStatus || undefined,
		itemAccount: params.itemAccount || undefined,
		itemGroup: params.itemGroup || undefined,
		compCd: params.compCd || undefined,
	};

	// view는 쿼리 파라미터로, 나머지는 body로 전송
    return await getData<ResponseDto<string>>(url, {
        params: { ...requestParams, view },
    });
};

// 하위 호환을 위한 기존 함수들 (deprecated)
export const getPUR5010_R01List = async (searchType: string, params: Partial<PUR5010_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/${searchType}`;
	const requestParams = {
		logicCenter: params.logicCenter || undefined,
		warehouseCd: params.warehouseCd || undefined,
		itemCd: params.itemCd || undefined,
		brandCd: params.brandCd || undefined,
		itemStatus: params.itemStatus || undefined,
		itemAccount: params.itemAccount || undefined,
		itemGroup: params.itemGroup || undefined,
		compCd: params.compCd || undefined,
		listLength,
		view: 'item'
	};

    return await getData<ResponseDto<PUR5010_R01Dto[]>>(url, { params: requestParams });
};
